var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarineLantern5Nm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2504,
    y: 325,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2504 -325)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2504,
    y: 325,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3545.65 734.227C3900.81 734.69 4187.82 1017.19 4186.71 1365.21 4185.59 1713.23 3896.77 1994.98 3541.61 1994.51 3186.44 1994.05 2899.43 1711.55 2900.54 1363.53 2901.66 1015.8 3190.02 734.174 3544.89 734.226L3544.48 936.909C3301.25 937.078 3103.7 1128.6 3103.23 1364.68 3102.75 1600.76 3299.54 1792 3542.77 1791.83 3786 1791.66 3983.55 1600.14 3984.03 1364.06 3984.5 1128.18 3788.02 937.016 3545 936.909Z",
    fill: "#FFEA01",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineLantern5Nm);
export default __webpack_public_path__ + "static/media/MarineLantern5NM.f1d85ba907203badf02fcec2a7c3a1a7.svg";
export { ForwardRef as ReactComponent };